import request from '@/api/request'
// 获取学时详情页数据
export function getClassHoursDetailApi(data:any){
    let url = '/api/manager/userscheduling/hours/detail';
    return request({
        url: url,
        method: 'post',
        data
    })
}


// 获取当年的学时详细
export function getClassHoursDetailCurrentApi(data:any){
    let url = '/api/manager/userscheduling/hours/detail/current';
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 获取历年的学时详细
export function getClassHoursDetailOverApi(data:any){
    let url = '/api/manager/userscheduling/hours/detail/overyear';
    return request({
        url: url,
        method: 'post',
        data
    })
}


//  获取年份详细信息
export function getUserHoursDetailApi(data:any){
    let url = '/api/manager/userscheduling/hours/detail/year';
    return request({
        url: url,
        method: 'post',
        data
    })
}